import React from 'react';

const botFooter = () => {
    return (
        <div>
            <div className='bg-zinc-900 pt-20 flex justify-center text-center text-gray-500'>
                TOP BBQ & NOODLE &nbsp; 1425 ARTESIA BLvD UNIT 21 GARDENA, CA 90248 &nbsp; (310) 819-8413
            </div>

        </div>
    );
}

export default botFooter; 